export default {
  flashSalesTag: {
    id: 'flash_sales_product_card_tag',
    defaultMessage: '{price} off at checkout',
  },
  competitiveFlashSalesTag: {
    id: 'competitive_price_product_card_tag',
    defaultMessage: 'Great price',
  },
  sellerFlashSalesTag: {
    id: 'seller_flash_sales_product_card_tag',
    defaultMessage: '{percentage} price drop',
  },
  sellerFlashSalesTagTooltip: {
    id: 'seller_flash_sales_tag_tooltip',
    defaultMessage:
      'Offer valid from {start_date} to {end_date}. {percentage}% discount applied to the lowest price observed on Back Market during the 30-day period immediately before the discount for this offer (lowest price: {lowest_price}). Subject to stock availability.',
  },
} as const
